import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useHeadsObserver } from '../../../../helpers/hook';
import colors from '../../../../helpers/colors';
import globalText from '../../../../helpers/globalText';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons/faAngleRight';
import Cta from '../../../atoms/CTA-Outline/index';

const Heading = styled.p`
    font-weight: 900;
    font-size: 17px;
    color: black;
    line-height: 25px;
`;

const TOCNav = styled.nav`
	padding: 16px;
    width: 340px;
	align-self: flex-start;
	position: -webkit-sticky;
	position: sticky;
	top: 78px;
	max-height: calc(100vh - 70px);
	overflow: auto;

    ul {
        list-style-type: none;
    } 
    .active-toc {
        box-shadow: 0px 5px 8px 0px #00000033;
        border-radius: 15px;
        padding: 12px 24px 12px 18px;

        .toc-arrow {
            color: ${colors.mvBlue}
        }
    }

    @media (max-width: 769px) {
        display: none;
    }
`;
/* .head3{
    margin-left: 10px;
    list-style-type: circle;
}

.head4 {
    margin-left: 20px;
    list-style-type: square;
}  */

const TOCLink = styled.a`
    color: ${colors.paragraphTextColor};
    text-decoration: none;
`;

const TOCItem = styled.li`
	margin-bottom: 15px;
    margin: 20px 0;
    padding-left: 24px;
    display: flex;
    align-items: center;

    .toc-arrow {
        margin-right: 18px;
        color ${colors.paragraphTextColor}
    }    
`;


const Demo = styled.div`
    background: ${colors.mvLightestBlue};
    width: 100%;
    padding: 25px;
    border-radius: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 50px;
`;

const DemoText = styled.p`
    font-weight: 900;
    font-size: 21px;
    line-height: 25px;
    margin-bottom: 33px;
    text-align: center;
`;

const TableOfContents = () => {
	const [headings, setHeadings] = useState([]);
    const {activeId} = useHeadsObserver()

	useEffect(() => {
		const elements = Array.from(document.querySelectorAll("h2, h3, h4")).map(
			(elem) => ({
				id: elem.id,
				text: elem.innerText,
				level: Number(elem.nodeName.charAt(1)),
			})
		);
		setHeadings(elements);
	}, []);

    const getClassName = (level) => {
        switch (level) {
          case 2:
            return 'head2'
          case 3:
            return 'head3'
          case 4:
            return 'head4'
          default:
            return null
        }
      }

    const scrollToHeading = (id) => {
        const element = document.getElementById(id);
        const offset = 100;
        const y = element.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: y, behavior: 'smooth' });
    };

	return (
		<TOCNav>
            {headings.length > 0 ? 
            <>
            <Heading>Table of Contents</Heading>

			<ul>
				{headings.map((heading) => {
                    return (
                        <TOCItem key={heading.id} className={activeId === heading.id ? "active-toc "  + getClassName(heading.level): getClassName(heading.level)}>
                            <FontAwesomeIcon icon={faAngleRight} alt="Icon pointing right" className="toc-arrow" />

                            <TOCLink
                                href={`#${heading.id}`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    scrollToHeading(heading.id);
                                }}
                            >
                                {heading.text}
                            </TOCLink>
                        </TOCItem>
                    )
                })}
			</ul>
            </>
            : null}
            <Demo>
                <DemoText>Ready to see how Motivosity can connect your company?</DemoText>
                <Cta ctaHref={"/demo/"} ctaText={globalText.watchADemo} />
            </Demo>
		</TOCNav>
	);
};

export default TableOfContents;
